"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _identity2 = _interopRequireDefault(require("lodash/fp/identity"));

var _flow2 = _interopRequireDefault(require("lodash/fp/flow"));

var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));

var _mapValues2 = _interopRequireDefault(require("lodash/fp/mapValues"));

var _isArray2 = _interopRequireDefault(require("lodash/fp/isArray"));

var _normalize = _interopRequireDefault(require("./normalize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

// @ts-ignore
var mapValuesWithKey = _mapValues2.default.convert({
  cap: false
});

var _default = function _default(_a) {
  var schema = _a.schema,
      entityKey = _a.entityKey,
      preProcess = _a.preProcess,
      dataKey = _a.dataKey,
      processValue = _a.processValue,
      postProcess = _a.postProcess;
  return function (originalData, _a) {
    var payload = _a.payload,
        meta = _a.meta;
    return (0, _flow2.default)(dataKey ? (0, _prop2.default)(dataKey) : _identity2.default, preProcess ? function (data) {
      return preProcess({
        originalData: originalData,
        meta: meta,
        payload: payload,
        data: data
      });
    } : _identity2.default, function (data) {
      return (0, _normalize.default)((0, _isArray2.default)(data) ? [schema] : schema)(data);
    }, (0, _prop2.default)("entities." + (entityKey || schema.key)), mapValuesWithKey(function (value, id) {
      return __assign(__assign({}, originalData[id]), processValue ? processValue({
        meta: meta,
        originalData: originalData,
        payload: payload,
        value: value
      }) : value);
    }), function (newData) {
      return __assign(__assign({}, originalData), newData);
    }, postProcess ? function (data) {
      return postProcess({
        data: data,
        originalData: originalData,
        meta: meta,
        payload: payload
      });
    } : _identity2.default)(payload);
  };
};

exports.default = _default;